import React, { createContext, useContext } from 'react'

export type PostHogReachabilityValue = {
  isBlocked: boolean
}

const PostHogReachabilityContext = createContext<PostHogReachabilityValue>({
  isBlocked: false,
})

export function usePostHogReachability(): PostHogReachabilityValue {
  return useContext(PostHogReachabilityContext)
}

export default PostHogReachabilityContext
